export default function isIOS() {
	return !!window.navigator.userAgent.toLowerCase().match(/(ipad|iphone|ipod)/g);
}
